import * as React from 'react';

interface PanelHeaderProps {
  title: React.ReactNode;
  extra?: JSX.Element[];
  overAlert?: React.ReactNode;
}

const PanelHeader = (props: PanelHeaderProps) => {
  const { extra, title, overAlert } = props;

  return (
    <div className="normalheader transition animated fadeIn">
      <div className="hpanel">
        {overAlert || null}
        <div className="panel-body" style={{ display: 'flex' }}>
          <h2 className="font-light m-b-xs">{title}</h2>
          <div className="panel-header-extra">{extra}</div>
        </div>
      </div>
    </div>
  );
};

export default PanelHeader;
